import { useState } from 'react';
import Checkbox from '../../../../common/simple/Checkbox';
import ActionsCard from "./ActionsCard";

const ActionsCardWithCheckbox = ({ date, amount, currency, paymentType, paymentObject, paymentMethod, documentNumber, checked = false, paymentID, method, onChange }) => {
    const [checkedState, setCheckedState] = useState(checked);

    const onCheckboxChange = () => {
        onChange(paymentID, !checkedState)
        setCheckedState(!checkedState);
    };

    return (
        <div className='action-with-checkbox'>
            <Checkbox 
                checked={checkedState}
                onChange={onCheckboxChange}
                className='check'
                size={20}
                label={<ActionsCard
                    noFile
                    date={date} 
                    amount={amount}
                    currency={currency}
                    paymentType={paymentType} 
                    paymentObject={paymentObject} 
                    paymentMethod={paymentMethod} 
                    documentNumber={documentNumber}
                    paymentID={paymentID}
                    method={method}
                />}
            />        
        </div>
    );
};

export default ActionsCardWithCheckbox;